"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const String_1 = require("helpers/String");
class ModuleUtil {
    filterByName(modules, search) {
        const normalizedSearch = (0, String_1.normalizeIgnoreCase)(search);
        if (!normalizedSearch) {
            return modules;
        }
        return modules.filter((module) => {
            return (0, String_1.normalizeIgnoreCase)(module.name).includes(normalizedSearch);
        });
    }
}
exports.default = new ModuleUtil();
